module.exports = __webpack_public_path__ + "media/images/StanfordMagLogoWMagazine_2C-caadbf3032376472d0d4d76b6c0971e0.svg";